import React from 'react';
import Select from 'components/common/Select';
import { usaStates } from '../../utils';
import './styles.scss';

interface IOwnProps {
  testidProp: string;
  selectedState: string;
  onChange: (data: any) => void;
}

class SelectState extends React.Component<IOwnProps, {}> {
  handleChangeLocation = (option: any) => {
    this.props.onChange({ target: { value: option.value } });
  };

  render() {
    const { selectedState, testidProp } = this.props;
    const options = usaStates.map((state) => ({
      value: state.abbrevitaion,
      label: state.abbrevitaion,
    }));

    return (
      <div styleName="styled-select" data-testid={testidProp}>
        <Select
          options={options}
          selectedOption={{ value: selectedState, label: selectedState }}
          onChange={this.handleChangeLocation}
        />
      </div>
    );
  }
}

export default SelectState;
